import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'pictureList',
		component: function() {
			return import(/* webpackChunkName: "about" */ '../views/PictureList.vue');
		},
		title: '图片列表',
	},
	{
		path: '/AboutMe',
		name: 'AboutMe',
		component: function() {
			return import(/* webpackChunkName: "about" */ '../views/AboutMe.vue');
		},
		title: 'aboutme',
	},
	{
		path: '/ProjectsCont',
		name: 'ProjectsCont',
		component: function() {
			return import(/* webpackChunkName: "about" */ '../views/ProjectsCont.vue');
		},
		title: 'ProjectsCont',
	},
	{
		path: '/Countent',
		name: 'Countent',
		component: function() {
			return import(/* webpackChunkName: "about" */ '../views/Countent.vue');
		},
		title: 'Countent',
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
	console.log(from.path, '跳转到PC--->', to.path);
	if (to.path.includes('-')) {
		sessionStorage.setItem('listUpTitle', to.path.split('-')[1]);
		let path = to.path.split('-')[0];
		next(path);
	} else {
		next();
	}
});

export default router;
